<script lang="ts" setup>

</script>

<template>
  <!-- <Dashboard /> -->
  <div />
</template>
